
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 95 96","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M80.772 81.091H66.773V59.156c0-5.231-.106-11.962-7.295-11.962-7.299 0-8.413 5.691-8.413 11.576V81.09h-14V35.984h13.448v6.148h.181c1.88-3.545 6.448-7.287 13.275-7.287 14.183 0 16.807 9.335 16.807 21.487v24.76h-.004zm-59.517-51.28c-4.506 0-8.126-3.647-8.126-8.134a8.12 8.12 0 018.126-8.125c4.49 0 8.13 3.643 8.13 8.125 0 4.487-3.643 8.134-8.13 8.134zm7.02 51.28H14.235V35.984h14.038V81.09zM87.774.534H7.209C3.353.534.233 3.582.233 7.344v80.913c0 3.765 3.12 6.81 6.976 6.81h80.554c3.852 0 7.004-3.045 7.004-6.81V7.344c0-3.762-3.152-6.81-7.004-6.81h.012z","fill":"#0073B1"}})])
          )
        }
      }
    